import $ from 'jquery';

export default function() {
  if ($(window).width() <= 768) {
    if ($('.template-product').length > 0) {
      $('[data-sticky-add-cart]').remove();
      const mobile_sticky_cart = $('[data-mobile-sticky-add-cart]').position().top;
      $(window).scroll(() => {
        if ($(window).scrollTop() > mobile_sticky_cart) {
          $('[data-mobile-sticky-add-cart]').addClass('show');
        } else {
          $('[data-mobile-sticky-add-cart]').removeClass('show');
        }
      });
      $(document).on('click', '[data-sticky-close]', (e) => {
        const $close_button = $(e.currentTarget);
        $close_button.closest('[data-mobile-sticky-add-cart]').removeClass('show');
        $(window).unbind('scroll');
      });
    }
  }
  if ($(window).width() > 768) {
    if ($('.template-product').length > 0) {
      $('[data-mobile-sticky-add-cart]').remove();

      const sticky_cart = $('[data-sticky-add-cart]').position().top - 300;
      $(window).scroll(() => {
        if ($(window).scrollTop() > sticky_cart) {
          $('[data-sticky-add-cart]').addClass('show');
        } else {
          $('[data-sticky-add-cart]').removeClass('show');
        }
      });
    }
  }
  $(document).trigger('scroll');

  $(document).on('click', '[data-sticky-add-to-cart]', (e) => {
    $(e.currentTarget).closest('[data-section-type="product"]').find('[data-add-to-cart]').eq(0).trigger('click');
  });
}
